export default "__VITE_ASSET__D$WsvYyR__"